<template>
  <div class="e2e-code-listing">
    <div style="background-color: lightgray;" v-if="fragment.showLine">
      <pre style="float: left; background-color: lightgray; min-width: 2em; padding-left: 4px">{{lineNumbers}}</pre>
      <pre style="background-color: whitesmoke; padding-left: 5px;">{{fragment.code}}</pre>
    </div>
    <div v-else>
      <pre style="background-color: whitesmoke;">{{fragment.code}}</pre>
    </div>
  </div>
</template>

<script>
/**
 * fragment.language    : string | null     // name of the language e.g. 'groovy', 'java'
 * fragment.showLine    : boolean           // show line numbers?
 * fragment.lineStep    : number            // line number step
 * fragment.code        : string            // code to show
 */
export default {
  name: "fragment-code-listing",
  props: ["fragment"],
  computed: {
    lineNumbers() {
      const lineStep = this.fragment.lineStep;
      return this.fragment.code
        .split("\n")
        .map((_, index) => {
          if ((index + 1) % lineStep === 0) {
            return `${index + 1}`;
          } else {
            return "";
          }
        })
        .join("\n");
    }
  }
};
</script>
 

<style scoped>
</style>